/* eslint-disable */
/**
 * COPIED VERBATIM from src/app/components/direct/components/directFormat.js (commit 7772aebb).
 * Do not edit: kept byte-identical so a two-way diff against the source stays meaningful
 * while both modules coexist. Ashvini's module is scheduled for removal; when it goes,
 * this copy becomes the only one and the eslint-disable above should be dropped.
 */
/**
 * Prozo Direct — number formatting, in one place.
 *
 * RULE FOLLOWED: counts reuse formatNumber from helpers/UtilityHelper rather than a new
 * hand-rolled toLocaleString on every screen.
 *
 * DEVIATION, and why: currency does NOT use UtilityHelper's formatCurrency. Two reasons,
 * both of which would be visible defects on these screens —
 *   1. formatCurrency starts `if (!amt) return '-'`, so a genuine ZERO renders as a dash.
 *      Priced loss of ₹0.00 and a ₹0.00 platform fee are real values here, and showing them
 *      as "-" reads as missing data rather than as nil.
 *   2. It sets minimumFractionDigits: 0 with no maximum, so ₹99.30 renders "₹99.3" and ₹99
 *      renders "₹99". A column mixing 1 and 2 decimal places destroys the decimal alignment
 *      that the monospace tabular numerals exist to provide.
 * So money on these screens is fixed at two decimals, in this one function, rather than in
 * 36 inline template literals. If formatCurrency ever grows a fixed-decimals option, this
 * should collapse into it.
 */
import {formatNumber} from '../../../helpers/UtilityHelper'

/** Integer counts — shipments, accounts, pincodes. Reuses the shared helper. */
export const fmtCount = (n) => formatNumber(n)

/** Money, always two decimals so columns align on the decimal point. */
export const money = (n) => {
  const v = Number(n)
  if (!Number.isFinite(v)) return '—'
  return `₹${v.toFixed(2)}`
}

/** Money with no decimals, for large aggregate figures where paise are noise. */
export const moneyWhole = (n) => {
  const v = Number(n)
  if (!Number.isFinite(v)) return '—'
  return `₹${formatNumber(Math.round(v))}`
}

/** Percentages to one decimal, the precision the courier scorecard actually carries. */
export const pct = (n, dp = 1) => {
  const v = Number(n)
  if (!Number.isFinite(v)) return '—'
  return `${v.toFixed(dp)}%`
}
